import { Action, createReducer, on } from '@ngrx/store';
import {
  clearSelectCustomerGroupAction,
  loadCustomerGroupsAction,
  loadCustomerGroupsErrorAction,
  loadCustomerGroupsSuccessAction,
  selectCustomerGroupAction,
} from './customer-groups.actions';
import { CustomerGroupsState } from './customer-groups.state';

const initialState = new CustomerGroupsState();

const reducer = createReducer(
  initialState,
  on(loadCustomerGroupsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    newState.selectedCustomerGroup = null;
    return newState;
  }),
  on(loadCustomerGroupsSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.customerGroups = payload.customerGroups;
    return newState;
  }),
  on(loadCustomerGroupsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(selectCustomerGroupAction, (state, payload) => {
    const newState = { ...state };
    newState.selectedCustomerGroup = newState.customerGroups.find((group) => group.id === payload.customerGroupId);
    return newState;
  }),
  on(clearSelectCustomerGroupAction, (state) => {
    const newState = { ...state };
    newState.selectedCustomerGroup = null;
    return newState;
  })
);

export function customerGroupsReducer(state: CustomerGroupsState | null, action: Action) {
  return reducer(state, action);
}
